import workPlanParametrization from './workPlanParametrization'
import generalSettings from './generalSettings'
import chatbox from './chatbox'
import portfolio from './portfolio'
import report from './report'

import Profile from './profile/perfil'
import Validations from './lib/validations'
import Setters from './lib/setters'
import Requests from './lib/requests'
import Util from './lib/util'

import { periodPicker } from './components/period-picker'
import { searchBar } from './components/search-bar'
import { activitiesReview } from './components/activities-review'
import { history } from './components/history'

import { header } from './components/activities-review/header'
import { activitiesList } from './components/activities-review/activities-list'
import { handAvatar } from './components/activities-review/activities-list/hand-avatar'
import { medalAvatar } from './components/activities-review/activities-list/medal-avatar'
import { listData } from './components/activities-review/activities-list/list-data'
import { activityTag } from './components/activities-review/activities-list/activity-tag'
import { projectTypeTag } from './workplan/extensionVisibility/projectFormulation/list/proposals/project-type-tag'
import { projectStateTag } from './workplan/extensionVisibility/extensionProjects/list/projects/project-state-tag'
import { projectVisibilityTag } from './workplan/extensionVisibility/visibility/list/projects/project-visibility-tag'

import { addActivity } from './components/activities-review/header/add-activity'
import { addActivityExtension } from './components/activities-review/header/add-activity-extension'

import { activityDetails } from './components/activities-review/activity-details'
import { detailsHeader } from './components/activities-review/activity-details/details-header'
import { mainInfo } from './components/activities-review/activity-details/main-info'
import { childrenActivities } from './components/activities-review/activity-details/children-activities'
import { entriesList } from './components/activities-review/activity-details/entries-list'
import { plannedActivities } from './components/activities-review/activity-details/planned-activities'
import { studentAttention } from './components/activities-review/activity-details/student-attention'
import { subject } from './components/activities-review/activity-details/subject'

import { listPanel } from './components/activities-review/list-panel'
import { indicator } from './components/activities-review/list-panel/indicator'
import { panelRouter } from './components/activities-review/list-panel/panel-router'
import { panelRouterEvaluation } from './components/panel-router-evaluation'

import { executionEntries } from './components/activities-review/modals/execution-entries'
import { registerExecution } from './components/activities-review/modals/register-execution'
import { addCustom } from './components/activities-review/activity-details/modals/add-custom'

export default angular.module('app.ufaculty', [workPlanParametrization, generalSettings, portfolio, Validations, Setters, Requests, chatbox, Util, Profile, report])
.component('periodPicker', periodPicker)
.component('searchBar', searchBar)
.component('activitiesReview', activitiesReview)
.component('history', history)

.component('addActivity', addActivity)
.component('addActivityExtension', addActivityExtension)

.component('header', header)
.component('activitiesList', activitiesList)
.component('handAvatar', handAvatar)
.component('medalAvatar', medalAvatar)

.component('listData', listData)
.component('activityTag', activityTag)
.component('projectTypeTag', projectTypeTag)
.component('projectStateTag', projectStateTag)
.component('projectVisibilityTag', projectVisibilityTag)

.component('activityDetails', activityDetails)
.component('detailsHeader', detailsHeader)
.component('mainInfo', mainInfo)
.component('childrenActivities', childrenActivities)
.component('entriesList', entriesList)
.component('plannedActivities', plannedActivities)
.component('studentAttention', studentAttention)
.component('subject', subject)

.component('listPanel', listPanel)
.component('indicator', indicator)
.component('panelRouter', panelRouter)
.component('panelRouterEvaluation', panelRouterEvaluation)

.component('executionEntries', executionEntries)
.component('registerExecution', registerExecution)

.component('addCustom', addCustom)
.name



// WEBPACK FOOTER //
// ./src/app/u-faculty/index.js